<template>
  <b-container v-if="!isLoadingGet" fluid="lg" class="profile">
    <b-row class="justify-content-center my-5">
      <b-col sm="10" md="9" lg="8">
        <b-row class="mb-4">
          <b-col>
            <h3>{{ $t("general.ProfileInfo") }}</h3>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col sm="6" class="mb-3 mb-sm-0">
            <label>{{ $t("general.Nom") }}</label>
            <b-input :value="user.firstname" @input="updateUser('firstname', $event)" />
          </b-col>
          <b-col sm="6">
            <label>{{ $t("general.Prénom") }}</label>
            <b-input :value="user.lastname" @input="updateUser('lastname', $event)" />
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col sm="6" class="mb-3 mb-sm-0">
            <label>{{ $t("general.Phone") }}</label>
            <b-input :value="user.phone" @input="updateUser('phone', $event)" />
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col sm="6" class="mb-3 mb-sm-0">
            <label>{{ $t("general.Username") }}</label>
            <b-input :value="user.username" disabled @input="updateUser('username', $event)" />
          </b-col>
          <b-col sm="6">
            <label>{{ $t("general.Email") }}</label>
            <b-input :value="user.email" @input="updateUser('email', $event)" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Timezone</label>
            <v-select
              ref="v-select"
              v-model="timezone"
              :clearable="false"
              class=""
              :options="timezones"
              @input="selectTimezone($event)"
            >
            </v-select>
          </b-col>
        </b-row>
        <hr class="my-5" />
        <b-row>
          <b-col>
            <b-form-file
              v-show="false"
              ref="uploadFile"
              v-model="file"
              type="file"
              accept=".jpg, .png, .gif"
              plain
              @change="setImage"
            ></b-form-file>
            <b-button
              class="btn-secondary btn-outline-blue mb-4 p-3"
              @click="$refs.uploadFile.$el.click()"
            >
              <font-awesome-icon class="mr-2" size="lg" :icon="['fas', 'cloud-upload-alt']" />
              <span>Télécharger le logo de l'agence</span>
            </b-button>
            <b-button
              v-if="croppedImagePreview"
              variant="outline-danger"
              class="mb-4 ml-3 p-3"
              @click="deleteLogo"
            >
              <font-awesome-icon class="mr-2" size="lg" :icon="['fas', 'trash-alt']" />
              <span>Supprimer le logo</span>
            </b-button>
            <vueCropper
              v-if="showCropper"
              ref="cropper"
              class="image-cropper"
              :img="initialImage"
              :output-size="outputSize"
              :output-type="outputType"
              :auto-crop="true"
              :auto-crop-width="autoCropWidth"
              :auto-crop-height="autoCropHeight"
              @realTime="realTime"
            ></vueCropper>
            <div v-if="showCropper" class="d-flex justify-content-between my-3">
              <b-button class="btn-secondary btn-outline-blue" @click="refreshCrop">
                <font-awesome-icon class="mr-1" size="lg" :icon="['fas', 'redo-alt']" />
                <span>Réinitialiser</span>
              </b-button>
              <b-button class="btn-secondary btn-outline-blue" @click="changeScale(1)">
                <font-awesome-icon class="mr-1" size="lg" :icon="['fas', 'search-plus']" />
                <span>Zoomer</span>
              </b-button>
              <b-button class="btn-secondary btn-outline-blue" @click="changeScale(-1)">
                <font-awesome-icon class="mr-1" size="lg" :icon="['fas', 'search-minus']" />
                <span>Dézoomer</span>
              </b-button>
              <b-button class="btn-secondary btn-outline-blue" @click="deleteCropImage">
                <font-awesome-icon class="mr-1" size="lg" :icon="['fas', 'trash-alt']" />
                <span>Effacer</span>
              </b-button>
            </div>
            <div v-if="croppedImagePreview">
              <h3 class="my-3">Logo de l'agence</h3>
              <b-img :width="autoCropWidth" :src="croppedImagePreview"></b-img>
            </div>
          </b-col>
          <b-col v-if="previews">
            <div class="d-flex align-items-center flex-column mt-5">
              <div
                class="show-preview mt-5"
                :style="{
                  width: previews.w + 'px',
                  height: previews.h + 'px',
                  overflow: 'hidden',
                  margin: '5px',
                }"
              >
                <div :style="previews.div">
                  <img :src="previews.url" :style="previews.img" alt="picture" />
                </div>
              </div>
              <div class="mt-5">
                <b-button class="btn-green" @click="crop">
                  <font-awesome-icon class="mr-2" size="lg" :icon="['fas', 'crop-alt']" />
                  <span>Confirmer le logo de l'agence</span>
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="my-5 justify-content-center">
          <b-col cols="auto">
            <b-button :disabled="isLoadingSave" class="button btn-blue" @click="UPDATE_USER">
              <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="save" />
              <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
              <span>{{ $t("general.enregistrer") }}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="my-5 justify-content-center">
          <b-col cols="auto">
            <b-button variant="light" class="text-danger" @click="logout">
              <font-awesome-icon class="mr-2" icon="sign-out-alt" />
              <span>{{ $t("general.Logout") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
  <appLoader v-else />
</template>

<script>
import User from "@/store/orm-axios/models/User";
import MediaMW from "@/middlewares/Media";
import UserMW from "@/middlewares/User";
import { VueCropper } from "vue-cropper";

export default {
  components: {
    VueCropper,
  },
  data() {
    return {
      userId: Number(localStorage.getItem("userId")),
      isLoadingGet: true,
      isLoadingSave: false,
      initialImage: null,
      initialFile: null,
      outputSize: 2,
      outputType: "png",
      autoCropWidth: 200,
      autoCropHeight: 150,
      croppedImagePreview: null,
      previews: null,
      showCropper: false,
      file: null,
      timezone: null,
    };
  },
  computed: {
    user() {
      return User.find(this.userId) || {};
    },
    defaultTimezone() {
      return localStorage.getItem("timezone");
    },
    timezones() {
      return this.$moment.tz.names();
    },
  },
  async created() {
    await UserMW.GET(this.userId)
      .then(res => {
        this.isLoadingGet = false;
      })
      .catch(err => {
        this.isLoadingGet = false;
      });
    if (this.user.mediaId) {
      await this.GET_MEDIA(this.user.mediaId);
    }
    if (!this.defaultTimezone) {
      this.setTimezone("Europe/Paris");
    } else {
      this.timezone = this.defaultTimezone;
    }
  },
  methods: {
    updateUser(key, value) {
      User.update({
        where: this.userId,
        data: { [key]: value },
      });
    },
    UPDATE_USER() {
      this.isLoadingSave = true;
      UserMW.PUT(this.user)
        .then(res => {
          this.isLoadingSave = false;
        })
        .catch(err => {
          this.isLoadingSave = false;
        });
    },
    async CREATE_MEDIA(croppedImageData) {
      await MediaMW.MEDIA_CREATE_FROM_BASE64({ image: croppedImageData }).then(res => {
        this.user.mediaId = res.response.data.id;
        localStorage.setItem("userMediaId", res.response.data.id);
        this.isLoadingSave = true;
        if (this.user.mediaId != null) {
          UserMW.PUT(this.user)
            .then(() => {
              this.isLoadingSave = false;
            })
            .catch(err => {
              this.isLoadingSave = false;
            });
        }
      });
    },
    GET_MEDIA(mediaId) {
      MediaMW.GET_LOGO_IN_BASE64(mediaId).then(res => {
        this.croppedImagePreview = res.file_as_base64_string;
      });
    },
    async DELETE_MEDIA() {
      await MediaMW.DELETE({ id: this.user.mediaId });
      this.user.mediaId = null;
      this.isLoadingSave = true;
      await UserMW.PUT(this.user)
        .then(() => {
          this.isLoadingSave = false;
        })
        .catch(err => {
          this.isLoadingSave = false;
        });
      localStorage.removeItem("userMediaId");
    },
    logout() {
      if (!process.env.VUE_APP_IS_WEB) {
        this.$store.dispatch("auth/logoutDesktop").then(() => {
          this.$router.push({ name: "login" });
        });
      } else {
        this.$store.dispatch("auth/logout").then(() => {
          this.$router.push({ name: "login" });
        });
      }
    },
    deleteLogo() {
      this.file = null;
      this.croppedImagePreview = null;
      if (this.user.mediaId) {
        this.DELETE_MEDIA(this.user.mediaId);
      }
    },
    setImage(e) {
      this.showCropper = true;
      const file = e.target.files[0];
      if (file.type.indexOf("image/") === -1) {
        console.log("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.initialImage = event.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        console.log("Sorry, FileReader API not supported");
      }
      this.initialFile = file;
    },
    crop() {
      this.$refs.cropper.getCropData(data => {
        // this.model = true;
        this.croppedImagePreview = data;
        this.deleteCropImage();
        this.CREATE_MEDIA(data.split(",")[1]);
      });
    },
    clearCrop() {
      this.$refs.cropper.clearCrop();
    },
    refreshCrop() {
      this.$refs.cropper.refresh();
    },
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    deleteCropImage() {
      this.showCropper = false;
      this.previews = null;
      this.initialImage = null;
      this.initialFile = null;
    },
    realTime(data) {
      this.previews = data;
    },
    setTimezone(timezone) {
      this.$moment.tz.setDefault(timezone);
      localStorage.setItem("timezone", timezone);
      this.user.timezone = timezone;
      this.UPDATE_USER();
    },
    selectTimezone(timezone) {
      this.setTimezone(timezone);
    },
  },
};
</script>
